export default "//cloud.imgsmail.ru/cloud.mail.ru/183089/img/build/downloadAppModal/1.png";